export const concentration = [
  { value: "Residential", label: "Residential" },
  { value: "Commercial & Retail", label: "Commercial & Retail" },
  { value: "Cultural & Civic", label: "Cultural & Civic" },
  {
    value: "Industrial & Manufacturing Architecture",
    label: "Industrial & Manufacturing Architecture",
  },
  {
    value: "Healthcare & Wellness Architecture",
    label: "Healthcare & Wellness Architecture",
  },
  {
    value: "Public Infrastructure & Civic Buildings",
    label: "Public Infrastructure & Civic Buildings",
  },
  {
    value: "Historical & Heritage Architecture",
    label: "Historical & Heritage Architecture",
  },
  {
    value: "Recreation & Sports Architecture",
    label: "Recreation & Sports Architecture",
  },
  {
    value: "Environmental & Sustainable Architecture",
    label: "Environmental & Sustainable Architecture",
  },
  {
    value: "Urban Planning & Master Planning",
    label: "Urban Planning & Master Planning",
  },
  {
    value: "Interior Design & Interiors",
    label: "Interior Design & Interiors",
  },
  {
    value: "Landscape Architecture & Design",
    label: "Landscape Architecture & Design",
  },
  {
    value: "Temporary & Installation Architecture",
    label: "Temporary & Installation Architecture",
  },
  {
    value: "Emerging & Experimental Architecture",
    label: "Emerging & Experimental Architecture",
  },
  {
    value: "Sustainability & Green Building",
    label: "Sustainability & Green Building",
  },
  { value: "Multidisciplinary", label: "Multidisciplinary" },
];

export const concentrationProduct = [
  { value: "Accessibility", label: "Accessibility" },
  { value: "Bathroom and Kitchen", label: "Bathroom and Kitchen" },
  { value: "Furniture and Storage", label: "Furniture and Storage" },
  { value: "Lighting and Electrical", label: "Lighting and Electrical" },
  {
    value: "Architectural Elements and Systems",
    label: "Architectural Elements and Systems",
  },
  { value: "Materials and Finishes", label: "Materials and Finishes" },
  { value: "Outdoor and Landscape", label: "Outdoor and Landscape" },
  { value: "Plumbing and HVAC", label: "Plumbing and HVAC" },
  { value: "Technology and Equipment", label: "Technology and Equipment" },
  { value: "Hardware and Fixtures", label: "Hardware and Fixtures" },
  { value: "Miscellaneous", label: "Miscellaneous" },
];

export const industry = [
  { value: "Architecture", label: "Architecture" },
  { value: "Landscape Architecture", label: "Landscape Architecture" },
  { value: "Interior Design", label: "Interior Design" },
  { value: "Electrical Engineering", label: "Electrical Engineering" },
  { value: "Structural Engineering", label: "Structural Engineering" },
  { value: "Civil Engineering", label: "Civil Engineering" },
  { value: "Mechanical Engineering", label: "Mechanical Engineering" },
  { value: "Geotechnical Engineering", label: "Geotechnical Engineering" },
  {
    value: "Construction and Building Industry",
    label: "Construction and Building Industry",
  },
  {
    value: "Urban and Regional Planning",
    label: "Urban and Regional Planning",
  },
  {
    value: "Environmental and Sustainability Design",
    label: "Environmental and Sustainability Design",
  },
  { value: "Lighting Design", label: "Lighting Design" },
  { value: "Acoustic Design", label: "Acoustic Design" },
  {
    value: "Technology and Information Systems in Architecture",
    label: "Technology and Information Systems in Architecture",
  },
  {
    value: "Accessibility and Inclusive Design",
    label: "Accessibility and Inclusive Design",
  },
  { value: "Graphic Design", label: "Graphic Design" },
  { value: "Architectural Rendering", label: "Architectural Rendering" },
  { value: "Professional Photography", label: "Professional Photography" },
  { value: "Building Materials", label: "Building Materials" },
];

export const educationDegree = [
  { label: "PHD", value: "PHD" },
  { label: "Master", value: "Master" },
  { label: "Bachelors", value: "Bachelors" },
];


export const operationRange = [
  { label: "National", value: "National" },
  { label: "International", value: "International" },

];

export const filters = [
  {
    id: "name",
    name: "Architect Name",
  },
  {
    id: "area",
    name: "Area",
    options: [
      { value: "Micro", label: "Up to 500 sq. ft." },
      { value: "Mini", label: "501 - 2,000 sq. ft." },
      { value: "Small", label: "2,001 - 10,000 sq. ft." },
      { value: "Medium", label: "10,001 - 50,000 sq. ft." },
      { value: "Large", label: "50,001 - 200,000 sq. ft." },
      { value: "Major", label: "200,001 - 1,000,000 sq. ft." },
      { value: "Urban", label: "1,000,001 - 10,000,000 sq. ft." },
      { value: "Master", label: "10,000,001 sq. ft - +" },
    ],
  },
  {
    id: "typologySubCategory",
    name: "Typology",
    options: [
      {
        value: "Residential",
        label: "Residential",
        subcategories: [
          { value: "Single-Family Homes", label: "Single-Family Homes" },
          {
            value: "Apartments & Multi-Family Housing",
            label: "Apartments & Multi-Family Housing",
          },
          { value: "Housing Developments", label: "Housing Developments" },
          { value: "Affordable Housing", label: "Affordable Housing" },
          { value: "Luxury Residences", label: "Luxury Residences" },
          {
            value: "Adaptive Reuse Residential",
            label: "Adaptive Reuse Residential",
          },
          { value: "Co-Housing Communities", label: "Co-Housing Communities" },
          {
            value: "Senior Living Facilities",
            label: "Senior Living Facilities",
          },
          { value: "Student Dormitories", label: "Student Dormitories" },
          { value: "Micro-Apartments", label: "Micro-Apartments" },
          { value: "Mixed-Use Developments", label: "Mixed-Use Developments" },
          { value: "Townhouses", label: "Townhouses" },
        ],
      },
      {
        value: "Commercial & Retail",
        label: "Commercial & Retail",
        subcategories: [
          { "value": "Office Building", "label": "Office Building" },
          { "value": "Retail Space", "label": "Retail Space" },
          { "value": "Mixed-Use Development", "label": "Mixed-Use Development" },
          { "value": "Shopping Center", "label": "Shopping Center" },
          { "value": "Hospitality (Hotels & Resorts)", "label": "Hospitality (Hotels & Resorts)" },
          { "value": "Restaurant & Cafe", "label": "Restaurant & Cafe" },
          { "value": "Corporate Headquarters", "label": "Corporate Headquarters" },
          { "value": "Retail Store", "label": "Retail Store" },
          { "value": "Big-Box Retailer", "label": "Big-Box Retailer" },
          { "value": "Pop-Up Shop", "label": "Pop-Up Shop" },
          { "value": "E-commerce Warehouse", "label": "E-commerce Warehouse" }
        ],
      },
      {
        value: "Cultural & Civic",
        label: "Cultural & Civic",
        subcategories: [
          { "value": "Museums & Cultural Centers", "label": "Museums & Cultural Centers" },
          { "value": "Theaters & Performing Arts Centers", "label": "Theaters & Performing Arts Centers" },
          { "value": "Libraries", "label": "Libraries" },
          { "value": "Civic Buildings", "label": "Civic Buildings" },
          { "value": "Educational Institutions", "label": "Educational Institutions" },
          { "value": "Religious Buildings", "label": "Religious Buildings" },
          { "value": "Exhibition Halls", "label": "Exhibition Halls" },
          { "value": "Government Offices", "label": "Government Offices" },
          { "value": "International Embassies", "label": "International Embassies" },
          { "value": "Nonprofit Organizations", "label": "Nonprofit Organizations" },
          { "value": "Cultural Institutes", "label": "Cultural Institutes" }
        ],
      },
      {
        value: "Industrial & Manufacturing Architecture",
        label: "Industrial & Manufacturing Architecture",
        subcategories: [
          { "value": "Factory", "label": "Factory" },
          { "value": "Warehouse", "label": "Warehouse" },
          { "value": "Industrial Park", "label": "Industrial Park" },
          { "value": "Research & Development Facility", "label": "Research & Development Facility" },
          { "value": "Industrial Renovation", "label": "Industrial Renovation" },
          { "value": "Auto Assembly Plant", "label": "Auto Assembly Plant" },
          { "value": "Steel Mill", "label": "Steel Mill" },
          { "value": "Chemical Factory", "label": "Chemical Factory" },
          { "value": "Textile Mill", "label": "Textile Mill" },
          { "value": "Printing Press", "label": "Printing Press" }
        ],
      },
      {
        "value": "Healthcare & Wellness Architecture",
        "label": "Healthcare & Wellness Architecture",
        "subcategories": [
          { "value": "Hospital", "label": "Hospital" },
          { "value": "Healthcare Clinic", "label": "Healthcare Clinic" },
          { "value": "Wellness Center & Spa", "label": "Wellness Center & Spa" },
          { "value": "Rehabilitation Facility", "label": "Rehabilitation Facility" },
          { "value": "Nursing Home", "label": "Nursing Home" },
          { "value": "Mental Health Facility", "label": "Mental Health Facility" },
          { "value": "Yoga & Wellness Center", "label": "Yoga & Wellness Center" },
          { "value": "Veterinary Clinic", "label": "Veterinary Clinic" },
          { "value": "Health Research Center", "label": "Health Research Center" },
          { "value": "Health Insurance Office", "label": "Health Insurance Office" },
          { "value": "Fitness Gym & Studio", "label": "Fitness Gym & Studio" },
          { "value": "Pharmacy", "label": "Pharmacy" }
        ]
      },
      
      {
        "value": "Public Infrastructure & Civic Buildings",
        "label": "Public Infrastructure & Civic Buildings",
        "subcategories": [
          { "value": "Airport", "label": "Airport" },
          { "value": "Train Station", "label": "Train Station" },
          { "value": "Bus Terminal", "label": "Bus Terminal" },
          { "value": "Bridge", "label": "Bridge" },
          { "value": "Highway", "label": "Highway" },
          { "value": "Port", "label": "Port" },
          { "value": "Harbor", "label": "Harbor" },
          { "value": "Energy Infrastructure", "label": "Energy Infrastructure" },
          { "value": "Utility Infrastructure", "label": "Utility Infrastructure" },
          { "value": "Park", "label": "Park" },
          { "value": "Plaza", "label": "Plaza" },
          { "value": "Public Space", "label": "Public Space" },
          { "value": "Auditorium", "label": "Auditorium" },
          { "value": "Toll Booth", "label": "Toll Booth" },
          { "value": "Disaster Response Center", "label": "Disaster Response Center" }
        ]
      },
      
      {
        "value": "Historical & Heritage Architecture",
        "label": "Historical & Heritage Architecture",
        "subcategories": [
          { "value": "Historic Preservation & Renovation", "label": "Historic Preservation & Renovation" },
          { "value": "Heritage Sites & Landmarks", "label": "Heritage Sites & Landmarks" },
          { "value": "Adaptive Reuse of Historic Buildings", "label": "Adaptive Reuse of Historic Buildings" },
          { "value": "Museums & Interpretive Centers", "label": "Museums & Interpretive Centers" },
          { "value": "Archaeological Museums", "label": "Archaeological Museums" },
          { "value": "Monument Conservation", "label": "Monument Conservation" },
          { "value": "Indigenous Cultural Centers", "label": "Indigenous Cultural Centers" },
          { "value": "Lighthouse Preservation", "label": "Lighthouse Preservation" },
          { "value": "Castle Preservation", "label": "Castle Preservation" },
          { "value": "Underwater Archaeological Sites", "label": "Underwater Archaeological Sites" },
          { "value": "Indigenous Reservations", "label": "Indigenous Reservations" }
        ]
      },
      
      {
        "value": "Recreation & Sports Architecture",
        "label": "Recreation & Sports Architecture",
        "subcategories": [
          { "value": "Sports Stadiums & Arenas", "label": "Sports Stadiums & Arenas" },
          { "value": "Recreation Centers & Gyms", "label": "Recreation Centers & Gyms" },
          { "value": "Sports Complexes", "label": "Sports Complexes" },
          { "value": "Stadium Renovations", "label": "Stadium Renovations" },
          { "value": "Outdoor Sports Facilities", "label": "Outdoor Sports Facilities" },
          { "value": "Fitness Clubs & Gyms", "label": "Fitness Clubs & Gyms" },
          { "value": "Tennis Courts", "label": "Tennis Courts" },
          { "value": "Golf Courses", "label": "Golf Courses" },
          { "value": "Ice Rinks", "label": "Ice Rinks" },
          { "value": "Community Pools", "label": "Community Pools" },
          { "value": "Hiking & Outdoor Trails", "label": "Hiking & Outdoor Trails" },
          { "value": "Sports Training Facilities", "label": "Sports Training Facilities" }
        ]
      },
      
      {
        "value": "Environmental & Sustainable Architecture",
        "label": "Environmental & Sustainable Architecture",
        "subcategories": [
          { "value": "Green Building Design", "label": "Green Building Design" },
          { "value": "Sustainable Housing", "label": "Sustainable Housing" },
          { "value": "Eco-Tourism Facilities", "label": "Eco-Tourism Facilities" },
          { "value": "Renewable Energy Installations", "label": "Renewable Energy Installations" },
          { "value": "LEED-Certified Buildings", "label": "LEED-Certified Buildings" },
          { "value": "Sustainable Farms", "label": "Sustainable Farms" },
          { "value": "Conservation Research Stations", "label": "Conservation Research Stations" },
          { "value": "Environmental Education Centers", "label": "Environmental Education Centers" },
          { "value": "Eco-Tourism Lodges", "label": "Eco-Tourism Lodges" }
        ]
      },
      
      {
        "value": "Urban Planning & Master Planning",
        "label": "Urban Planning & Master Planning",
        "subcategories": [
          { "value": "Urban Development Projects", "label": "Urban Development Projects" },
          { "value": "Master Plans for Cities & Regions", "label": "Master Plans for Cities & Regions" },
          { "value": "Transit-Oriented Developments", "label": "Transit-Oriented Developments" },
          { "value": "Sustainable Urban Planning", "label": "Sustainable Urban Planning" },
          { "value": "Mixed-Use Urban Design", "label": "Mixed-Use Urban Design" },
          { "value": "City Planning", "label": "City Planning" },
          { "value": "Town & City Hall", "label": "Town & City Hall" },
          { "value": "Urban Design", "label": "Urban Design" }
        ]
      },
      
      {
        "value": "Interior Design & Interiors",
        "label": "Interior Design & Interiors",
        "subcategories": [
          { "value": "Residential Interiors", "label": "Residential Interiors" },
          { "value": "Commercial Interiors", "label": "Commercial Interiors" },
          { "value": "Hospitality Interiors", "label": "Hospitality Interiors" },
          { "value": "Workplace Interiors", "label": "Workplace Interiors" },
          { "value": "Retail Interiors", "label": "Retail Interiors" },
          { "value": "Exhibition Design", "label": "Exhibition Design" }
        ]
      },
      
      {
        "value": "Landscape Architecture & Design",
        "label": "Landscape Architecture & Design",
        "subcategories": [
          { "value": "Parks", "label": "Parks" },
          { "value": "Gardens", "label": "Gardens" },
          { "value": "Urban Landscapes", "label": "Urban Landscapes" },
          { "value": "Landscape Restoration", "label": "Landscape Restoration" },
          { "value": "Sustainable Landscapes", "label": "Sustainable Landscapes" },
          { "value": "Botanical Gardens", "label": "Botanical Gardens" },
          { "value": "Nature Interpretation Centers", "label": "Nature Interpretation Centers" },
          { "value": "National Parks Visitor Centers", "label": "National Parks Visitor Centers" },
          { "value": "Urban Greening", "label": "Urban Greening" }
        ]
      },
      
      {
        value: "Temporary & Installation Architecture",
        label: "Temporary & Installation Architecture",
        subcategories: [
          {
            value: "art",
            label: "Art Installation",
          },
          {
            value: "pop-up",
            label: "Pop-Up Structure",
          },
          {
            value: "pavilion",
            label: "Temporary Pavilion",
          },
          {
            value: "exhibition",
            label: "Exhibition Design",
          },
          {
            value: "festival",
            label: "Festival Architecture",
          },
        ],
      },
      {
        value: "Emerging & Experimental Architecture",
        label: "Emerging & Experimental Architecture",
        subcategories: [
          { value: "Cutting-Edge Design", label: "Cutting-Edge Design" },
          {
            value: "Experimental Structures",
            label: "Experimental Structures",
          },
          {
            value: "Conceptual Architecture",
            label: "Conceptual Architecture",
          },
          {
            value: "Research-Based Projects",
            label: "Research-Based Projects",
          },
          {
            value: "Forward-Looking Innovations",
            label: "Forward-Looking Innovations",
          },
        ],
      },
      {
        value: "Sustainability & Green Building",
        label: "Sustainability & Green Building",
        subcategories: [
          { value: "Zero-Energy Buildings", label: "Zero-Energy Buildings" },
          { value: "Passive House Design", label: "Passive House Design" },
          { value: "Sustainable Materials", label: "Sustainable Materials" },
          { value: "Green Technologies", label: "Green Technologies" },
          {
            value: "Sustainable Community Planning",
            label: "Sustainable Community Planning",
          },
        ],
      },
    ],
  },
  {
    id: "year",
    name: "Year",
    options: [{ value: "2001", label: "2001" }],
  },
  {
    id: "location",
    name: "Location",
    options: [
      { value: "New York", label: "New York" },
      { value: "Los Angeles", label: "Los Angeles" },
      { value: "Chicago", label: "Chicago" },
      { value: "Houston", label: "Houston" },
      { value: "Phoenix", label: "Phoenix" },
    ],
  },
  {
    id: "phase",
    name: "Phase",
    options: [
      { value: "Build", label: "Build" },
      { value: "Unbuild", label: "Unbuild" },
      { value: "Educational", label: "Educational" },
      { value: "Competition", label: "Competition" },
    ],
  },
  {
    id: "style",
    name: "Architecture Style",
    options: [
      { value: "Art Deco", label: "Art Deco" },
      { value: "Bauhaus", label: "Bauhaus" },
      { value: "Biophilic", label: "Biophilic" },
      { value: "Brutalist", label: "Brutalist" },
      { value: "Contemporary", label: "Contemporary" },
      { value: "Deconstructivist", label: "Deconstructivist" },
      { value: "Eclectic", label: "Eclectic" },
      { value: "Expressionist", label: "Expressionist" },
      { value: "Futurist", label: "Futurist" },
      { value: "High-Tech", label: "High-Tech" },
      { value: "Industrial", label: "Industrial" },
      { value: "Minimalist", label: "Minimalist" },
      { value: "Modern", label: "Modern" },
      { value: "Neoclassical", label: "Neoclassical" },
      { value: "Organic", label: "Organic" },
      { value: "Parametric Design", label: "Parametric Design" },
      { value: "Postmodern", label: "Postmodern" },
      { value: "Scandinavian", label: "Scandinavian" },
      { value: "Sustainable Architecture", label: "Sustainable Architecture" },
      { value: "Vernacular", label: "Vernacular" },
    ],
  },
  {
    id: "material",
    name: "Materials",
    options: [
      { value: "Aluminum", label: "Aluminum" },
      { value: "Brick", label: "Brick" },
      { value: "Ceramic", label: "Ceramic" },
      { value: "Concrete", label: "Concrete" },
      { value: "Copper", label: "Copper" },
      { value: "Glass", label: "Glass" },
      { value: "Granite", label: "Granite" },
      { value: "Ice", label: "Ice" },
      { value: "Limestone", label: "Limestone" },
      { value: "Marble", label: "Marble" },
      { value: "Metal", label: "Metal" },
      { value: "Plaster", label: "Plaster" },
      { value: "Quartz", label: "Quartz" },
      { value: "Rammed Earth", label: "Rammed Earth" },
      { value: "Sandstone", label: "Sandstone" },
      { value: "Slate", label: "Slate" },
      { value: "Stone", label: "Stone" },
      { value: "Terracotta", label: "Terracotta" },
      { value: "Wood", label: "Wood" },
    ],
  },
  {
    id: "colors",
    name: "Colors",
    options: [
      { value: "Beige", label: "Beige" },
      { value: "Black", label: "Black" },
      { value: "Blue", label: "Blue" },
      { value: "Brown", label: "Brown" },
      { value: "Cream", label: "Cream" },
      { value: "Gold", label: "Gold" },
      { value: "Gray", label: "Gray" },
      { value: "Green", label: "Green" },
      { value: "Orange", label: "Orange" },
      { value: "Pink", label: "Pink" },
      { value: "Purple", label: "Purple" },
      { value: "Red", label: "Red" },
      { value: "White", label: "White" },
      { value: "Yellow", label: "Yellow" },
    ],
  },
  {
    id: "modeling",
    name: "Modeling",
    options: [
      { value: "Revit", label: "Revit" },
      { value: "Sketchup", label: "Sketchup" },
      { value: "Rhino", label: "Rhino" },
      { value: "Vectorworks", label: "Vectorworks" },
      { value: "3ds max", label: "3ds max" },
      { value: "Archicad", label: "Archicad" }
    ]

  },
  {
    id: "rendering",
    name: "Rendering",
    options: [
      { value: "Lumion", label: "Lumion" },
      { value: "Enscape", label: "Enscape" },
      { value: "Twinmotion", label: "Twinmotion" },
      { value: "V-ray", label: "V-ray" },
      { value: "Unreal", label: "Unreal" },
      { value: "D5", label: "D5" }
    ]

  }
];


export const Productfilters = [
  {
    id: "name",
    name: "Architect Name",
    
  },
  {
    id: "subCategory",
    name: "Type",
    options: [
      {
        value: "Accessibility",
        label: "Accessibility",
        subcategories: [
          { value: "Accessibility Bathroom", label: "Accessibility Bathroom" },
          { value: "Handicap Bathroom", label: "Handicap Bathroom" },
        ],
      },
      {
        value: "Bathroom and Kitchen",
        label: "Bathroom and Kitchen",
        subcategories: [
          { value: "bathroom_accessories", label: "Bathroom Accessories" },
          { value: "bathroom_furniture", label: "Bathroom Furniture" },
          { value: "bathrooms", label: "Bathrooms" },
          { value: "bathtubs", label: "Bathtubs" },
          { value: "bidet", label: "Bidet" },
          { value: "faucets", label: "Faucets" },
          { value: "kitchen_accessories", label: "Kitchen Accessories" },
          {
            value: "kitchen_furniture_countertops",
            label: "Kitchen Furniture / Countertops",
          },
          { value: "sinks", label: "Sinks" },
          { value: "toilets_bidets", label: "Toilets / Bidets" },
          { value: "toilets_urinals", label: "Toilets / Urinals" },
          { value: "urinals", label: "Urinals" },
        ],
      },
      {
        value: "Furniture and Storage",
        label: "Furniture and Storage",
        subcategories: [
          { value: "armchairs", label: "Armchairs" },
          { value: "couches", label: "Couches" },
          { value: "futons", label: "Futons" },
          { value: "poufs", label: "Poufs" },
          { value: "bedroom_furniture", label: "Bedroom Furniture" },
          { value: "benches", label: "Benches" },
          { value: "bicycle_rack", label: "Bicycle Rack" },
          { value: "bollards", label: "Bollards" },
          { value: "cabinets", label: "Cabinets" },
          { value: "chairs", label: "Chairs" },
          { value: "stools", label: "Stools" },
          { value: "chests", label: "Chests" },
          { value: "coffee_tables", label: "Coffee Tables" },
          { value: "console_tables", label: "Console Tables" },
          { value: "desks", label: "Desks" },
          { value: "meeting_rooms", label: "Meeting / Conference Rooms" },
          { value: "dining_tables", label: "Dining Tables" },
          { value: "display_cabinets", label: "Display Cabinets" },
          { value: "dresser", label: "Dresser / Closet / Armoire" },
          { value: "nightstands", label: "Night Stands" },
          { value: "office_furniture", label: "Office Furniture" },
          { value: "outdoor_furniture", label: "Outdoor Spaces Furniture" },
          { value: "patio_furniture", label: "Patio Furniture" },
          { value: "pedestals", label: "Pedestals" },
          { value: "seating_islands", label: "Seating Islands" },
          { value: "shelves", label: "Shelves / Cabinets / Bookshelves" },
          { value: "side_tables", label: "Side Tables" },
          { value: "sideboards", label: "Sideboards" },
          { value: "sofas", label: "Sofas" },
          { value: "storage", label: "Storage" },
          { value: "street_furniture", label: "Street Furniture" },
          { value: "tables", label: "Tables" },
          { value: "valuables_storage", label: "Valuables Storage / Safes" },
          { value: "wardrobes", label: "Wardrobes" },
          { value: "work_chairs", label: "Work Chairs" },
        ],
      },
      {
        value: "Lighting and Electrical",
        label: "Lighting and Electrical",
        subcategories: [
          { value: "awnings", label: "Awnings" },
          {
            value: "bulbs_spots_wall_lights",
            label: "Bulbs / Spots / Wall Lights",
          },
          { value: "floor_lamps", label: "Floor Lamps" },
          { value: "hanging_lamps", label: "Hanging Lamps" },
          { value: "lighting", label: "Lighting" },
          { value: "lights", label: "Lights" },
          { value: "switches", label: "Switches" },
          { value: "table_lamps", label: "Table Lamps" },
          { value: "wall_ceiling_lights", label: "Wall / Ceiling Lights" },
          { value: "window_shades_awnings", label: "Window Shades / Awnings" },
        ],
      },
      {
        value: "Architectural Elements and Systems",
        label: "Architectural Elements and Systems",
        subcategories: [
          { value: "beams_pillars", label: "Beams / Pillars" },
          { value: "bricks", label: "Bricks" },
          { value: "brickwork_masonry", label: "Brickwork / Masonry" },
          { value: "ceilings", label: "Ceilings" },
          { value: "concrete_systems", label: "Concrete Systems" },
          { value: "curtain_walls", label: "Curtain Walls" },
          { value: "doors_partitions", label: "Doors / Partitions" },
          {
            value: "elevators_conveying_equipment",
            label: "Elevators / Conveying Equipment",
          },
          {
            value: "enclosures_double_skin_facades",
            label: "Enclosures / Double Skin Facades",
          },
          { value: "facade_systems", label: "Facade Systems" },
          { value: "fasteners", label: "Fasteners" },
          { value: "floors", label: "Floors" },
          { value: "green_facades", label: "Green Facades" },
          { value: "green_roofs", label: "Green Roofs" },
          { value: "louvers_shutters", label: "Louvers / Shutters" },
          { value: "metal_framing_systems", label: "Metal Framing Systems" },
          { value: "partitions", label: "Partitions" },
          { value: "roofing", label: "Roofing" },
          { value: "stairs_railing", label: "Stairs / Railing" },
          { value: "suspension_systems", label: "Suspension Systems" },
          { value: "tensile_structures", label: "Tensile Structures" },
          { value: "walls", label: "Walls" },
          { value: "windows", label: "Windows" },
        ],
      },
      {
        value: "Materials and Finishes",
        label: "Materials and Finishes",
        subcategories: [
          { value: "adhesives_mortars", label: "Adhesives / Mortars" },
          { value: "aluminum_composites", label: "Aluminum Composites" },
          {
            value: "anti_corrosive_coatings",
            label: "Anti-Corrosive Coatings",
          },
          { value: "boards", label: "Boards" },
          { value: "ceramics", label: "Ceramics" },
          { value: "coatings_glazing", label: "Coatings / Glazing" },
          { value: "composites", label: "Composites" },
          { value: "concrete", label: "Concrete" },
          {
            value: "engineered_wood_flooring",
            label: "Engineered Wood Flooring",
          },
          {
            value: "fabric_textile_architecture",
            label: "Fabric / Textile Architecture",
          },
          { value: "fiber_cements_cements", label: "Fiber Cements / Cements" },
          { value: "finishes", label: "Finishes" },
          { value: "glass", label: "Glass" },
          { value: "glazed", label: "Glazed" },
          { value: "insulation", label: "Insulation" },
          {
            value: "laminated_wood_flooring",
            label: "Laminated Wood Flooring",
          },
          {
            value: "linoleum_vinyl_epoxy_urethane",
            label: "Linoleum / Vinyl / Epoxy / Urethane",
          },
          {
            value: "metal_chain_link_fencing",
            label: "Metal / Chain Link Fencing",
          },
          { value: "metals", label: "Metals" },
          {
            value: "mineral_organic_paints",
            label: "Mineral / Organic Paints",
          },
          { value: "paint", label: "Paint" },
          {
            value: "panels_prefabricated_assemblies",
            label: "Panels / Prefabricated Assemblies",
          },
          { value: "plastics_fibers", label: "Plastics / Fibers" },
          { value: "porcelain_stoneware", label: "Porcelain Stoneware" },
          { value: "rustic_ceramics", label: "Rustic Ceramics" },
          { value: "stones_masonry", label: "Stones / Masonry" },
          { value: "synthetics_asphalt", label: "Synthetics / Asphalt" },
          { value: "textures", label: "Textures" },
          { value: "thermal", label: "Thermal" },
          {
            value: "thermally_modified_wood",
            label: "Thermally Modified Wood",
          },
          { value: "tiles_mosaic_gresite", label: "Tiles / Mosaic / Gresite" },
          { value: "unglazed", label: "Unglazed" },
          { value: "vinyl_walls", label: "Vinyl Walls" },
          { value: "wallcovering_cladding", label: "Wallcovering / Cladding" },
          { value: "wallpaper", label: "Wallpaper" },
          { value: "wood", label: "Wood" },
          {
            value: "wood_boards_hpl_panels",
            label: "Wood Boards / HPL Panels",
          },
          { value: "wooden_flooring", label: "Wooden Flooring" },
        ],
      },
      {
        value: "Outdoor and Landscape",
        label: "Outdoor and Landscape",
        subcategories: [
          { value: "benches", label: "Benches" },
          { value: "tables", label: "Tables" },
          { value: "blinds", label: "Blinds" },
          { value: "mosquito_nets", label: "Mosquito Nets" },
          { value: "curtains", label: "Curtains" },
          { value: "bus_stop_shelters", label: "Bus Stop Shelters" },
          { value: "kiosks", label: "Kiosks" },
          { value: "fences", label: "Fences" },
          { value: "outdoor_lighting", label: "Outdoor Lighting" },
          { value: "planters", label: "Planters" },
          { value: "vegetation_protectors", label: "Vegetation Protectors" },
          { value: "pools", label: "Pools" },
          { value: "saunas", label: "Saunas" },
          { value: "street_furniture", label: "Street Furniture" },
          { value: "swings", label: "Swings" },
          { value: "urban_lighting", label: "Urban Lighting" },
          { value: "urban_pavements", label: "Urban Pavements" },
          { value: "urban_shading", label: "Urban Shading" },
        ],
      },
      {
        value: "Plumbing and HVAC",
        label: "Plumbing and HVAC",
        subcategories: [
          { value: "dishwasher", label: "Dishwashers" },
          { value: "washer", label: "Washers" },
          { value: "dryer", label: "Dryers" },
          { value: "faucet", label: "Faucets" },
          { value: "sink", label: "Sinks" },
          { value: "hvac", label: "Heating / Ventilation / Air Conditioning" },
          { value: "plumbing", label: "Plumbing" },
          { value: "shower_column", label: "Shower Columns" },
          { value: "shower_tray", label: "Shower Trays" },
          { value: "shower", label: "Showers" },
          { value: "toilet_bidet", label: "Toilets / Bidets" },
          { value: "toilet_urinal", label: "Toilets / Urinals" },
          { value: "urinal", label: "Urinals" },
          { value: "hvac", label: "Ventilation / Air Conditioning" },
          {
            value: "waste_container",
            label: "Waste Containers / Recycling Bins",
          },
          { value: "water_heating", label: "Water Heating" },
          { value: "waterproofing_sealant", label: "Waterproofing/Sealants" },
        ],
      },
      {
        value: "Technology and Equipment",
        label: "Technology and Equipment",
        subcategories: [
          { value: "automation", label: "Automation" },
          { value: "communications", label: "Communications" },
          {
            value: "connectivity_accessories",
            label: "Connectivity Accessories",
          },
          { value: "construction_equipment", label: "Construction Equipment" },
          { value: "digital_systems", label: "Digital Systems" },
          { value: "electrical_appliances", label: "Electrical Appliances" },
          { value: "home_automation", label: "Home Automation" },
          { value: "home_appliances", label: "Home Appliances" },
          { value: "mep_hvac", label: "MEP & HVAC" },
          { value: "renewable_energy", label: "Renewable Energy" },
          { value: "security", label: "Security" },
          { value: "technology", label: "Technology" },
        ],
      },
      {
        value: "Hardware and Fixtures",
        label: "Hardware and Fixtures",
        subcategories: [
          { value: "accessories", label: "Accessories / Joint Covers" },
          { value: "door_frames", label: "Door Frames" },
          { value: "drawers", label: "Drawers / Filing Cabinets / Shelves" },
          { value: "faucets", label: "Faucets" },
          { value: "handles", label: "Handles" },
          { value: "handshower", label: "Handshower" },
          { value: "hidden_joints", label: "Hidden Joints" },
          { value: "hinges", label: "Hinges" },
          { value: "hobs", label: "Hobs" },
          { value: "holders", label: "Holders" },
          { value: "hooks", label: "Hooks" },
          { value: "locks", label: "Locks" },
        ],
      },
      {
        value: "Miscellaneous",
        label: "Miscellaneous",
        subcategories: [
          { value: "acoustic", label: "Acoustic" },
          { value: "bars_wire_mesh", label: "Bars / Wire / Mesh" },
          { value: "carpets", label: "Carpets" },
          { value: "clothes_racks", label: "Clothes Racks" },
          { value: "decoration", label: "Decoration" },
          { value: "decorative_elements", label: "Decorative Elements" },
          { value: "educational", label: "Educational" },
        ],
      },
    ],
  },
  {
    id: "location",
    name: "Location",
   
  },
 
  {
    id: "properties",
    name: "Properties",
    options: [
      { value: "acoustic_insulation", label: "Acoustic Insulation" },
      { value: "anti_corrosion", label: "Anti-Corrosion" },
      { value: "antibacterial", label: "Antibacterial" },
      { value: "certification", label: "Certification" },
      { value: "chemical_free", label: "Chemical Free" },
      { value: "decay_resistant", label: "Decay Resistant" },
      { value: "energy_efficiency", label: "Energy Efficiency" },
      { value: "fireproof", label: "Fireproof" },
      { value: "insect_resistant", label: "Insect Resistant" },
      { value: "natural", label: "Natural" },
      { value: "non_slip", label: "Non-Slip" },
      { value: "recycled_material", label: "Recycled Material" },
      { value: "recycled_plastic", label: "Recycled Plastic" },
      { value: "security", label: "Security" },
      { value: "solar_control", label: "Solar Control" },
      { value: "stainless_rust_proof", label: "Stainless / Rust Proof" },
      { value: "synthetic", label: "Synthetic" },
      { value: "thermal_insulation", label: "Thermal Insulation" },
      { value: "thermally_modified", label: "Thermally Modified" },
      { value: "uv_protection", label: "UV Protection" },
      { value: "waterproof", label: "Waterproof" },
    ],
  },
  {
    id: "application",
    name: "Application",
    options: [
      { value: "Structural Components", label: "Structural Components" },
      { value: "flooring_tiling", label: "Flooring & Tiling" },
      {
        value: "insulation_waterproofing",
        label: "Insulation & Waterproofing",
      },
      { value: "roofing_materials", label: "Roofing Materials" },
      { value: "windows_doors", label: "Windows & Doors" },
      { value: "interior_finishes", label: "Interior Finishes" },
      { value: "landscaping_materials", label: "Landscaping Materials" },
      { value: "electrical_systems", label: "Electrical Systems" },
      { value: "plumbing_systems", label: "Plumbing Systems" },
      { value: "facades_cladding", label: "Facades & Cladding" },
      { value: "heating_cooling_systems", label: "Heating & Cooling Systems" },
      { value: "paints_coatings", label: "Paints & Coatings" },
      { value: "safety_security_systems", label: "Safety & Security Systems" },
      { value: "lighting_solutions", label: "Lighting Solutions" },
      { value: "acoustical_solutions", label: "Acoustical Solutions" },
    ],
  },

  {
    id: "materials",
    name: "Materials",
    options: [
      { value: "aluminum", label: "Aluminum" },
      { value: "bamboo", label: "Bamboo" },
      { value: "brick", label: "Brick" },
      { value: "ceramic", label: "Ceramic" },
      { value: "composite_materials", label: "Composite materials" },
      { value: "concrete", label: "Concrete" },
      { value: "fabric", label: "Fabric" },
      { value: "fiberglass", label: "Fiberglass" },
      { value: "fibre_cement", label: "Fibre cement" },
      { value: "glass", label: "Glass" },
      { value: "granite", label: "Granite" },
      { value: "ice", label: "Ice" },
      { value: "limestone", label: "Limestone" },
      { value: "marble", label: "Marble" },
      { value: "metal", label: "Metal" },
      { value: "paper", label: "Paper" },
      { value: "plaster", label: "Plaster" },
      { value: "plasterboard", label: "Plasterboard" },
      { value: "plastic", label: "Plastic" },
      { value: "policarbonato", label: "Policarbonato" },
      { value: "polypropylene", label: "Polypropylene" },
      { value: "porcelain", label: "Porcelain" },
      { value: "quartz", label: "Quartz" },
      { value: "rammed_earth", label: "Rammed Earth" },
      { value: "recycled_material", label: "Recycled material" },
      { value: "resin", label: "Resin" },
      { value: "sandstone", label: "Sandstone" },
      { value: "slate", label: "Slate" },
      { value: "stainless_steel", label: "Stainless steel" },
      { value: "steel", label: "Steel" },
      { value: "stone", label: "Stone" },
      { value: "terracotta", label: "Terracotta" },
      { value: "wallpaper", label: "Wallpaper" },
      { value: "wood", label: "Wood" },
      { value: "wood_based_panels", label: "Wood-based panels" },
    ],
  },
  {
    id: "Certification",
    name: "Certification",
    options:[
      { "value": "LEED", "label": "LEED" },
      { "value": "ENERGY STAR", "label": "ENERGY STAR" },
      { "value": "Green Seal", "label": "Green Seal" },
      { "value": "BREEAM", "label": "BREEAM" },
      { "value": "ISO 9001 (Quality Management)", "label": "ISO 9001 (Quality Management)" },
      { "value": "ISO 14001 (Environmental Management)", "label": "ISO 14001 (Environmental Management)" },
      { "value": "WELL Building Standard", "label": "WELL Building Standard" },
      { "value": "Passive House", "label": "Passive House" },
      { "value": "Cradle to Cradle Certified", "label": "Cradle to Cradle Certified" },
      { "value": "FSC (Forest Stewardship Council)", "label": "FSC (Forest Stewardship Council)" },
      { "value": "Greenguard Certification", "label": "Greenguard Certification" },
      { "value": "EPEAT", "label": "EPEAT" },
      { "value": "Living Building Challenge", "label": "Living Building Challenge" },
      { "value": "SITES for sustainable landscapes", "label": "SITES for sustainable landscapes" },
      { "value": "WaterSense", "label": "WaterSense" }
  ]
  
  },
];



export const collaborationTypes = [
  {
    label: "Architects",
    value:"Architects",
    participants: [
      {
        label: "Architects",
        value: "Architects"
      },
      {
        label: "Landscape Architects",
        value: "Landscape Architects"
      },
      {
        label: "Interior Designers",
        value: "Interior Designers"
      },
    ]

  },

  {
    label: "Engineers",
    value: "Engineers",
    participants: [
      {
        label: "Electrical Engineering",
        value: "Electrical Engineering"
      },
      {
        label: "Structural Engineering",
        value: "Structural Engineering"
      },
      {
        label: "Civil Engineering",
        value: "Civil Engineering"
      },
      {
        label: "Mechanical Engineering",
        value: "Mechanical Engineering"
      },
      {
        label: "Geotechnical Engineering",
        value: "Geotechnical Engineering"
      }
    ]
  },
  {
    label: "Builder",
    value:"Builder",
    participants:[
      {label: "Builders", value: "Builders"},
      {label: "Sub-Contractors", value:"Sub-Contractors"},
    ]
  },
  {
    label: "Team",
    value: "Team",
    participants: [
      {
        label: "Project Managers",
        value: "Project Managers"
      },
      {
        label: "Designers",
        value: "Designers"
      },
      {
        label: "Drafters",
        value: "Drafters"
      },
      {
        label: "Technicians",
        value: "Technicians"
      },
      {
        label: "Photographer",
        value: "Photographer"
      },
      {
        label: "3D Visualizer",
        value: "3D Visualizer"
      },
      {
        label: "Graphic Designer",
        value: "Graphic Designer"
      },
      {
        label: "Other Team Members",
        value: "Other Team Members"
      }
    ]
  },
  {
    label: "Product",
    value:"Product",
    participants: [
      {
        label: "Accessibility",
        value: "Accessibility"
      },
      {
        label: "Bathroom and Kitchen",
        value: "Bathroom and Kitchen"
      },
      {
        label: "Furniture and Storage",
        value: "Furniture and Storage"
      },
      {
        label: "Lighting and Electrical",
        value: "Lighting and Electrical"
      },
      {
        label: "Architectural Elements and Systems",
        value: "Architectural Elements and Systems"
      },
      {
        label: "Materials and Finishes",
        value: "Materials and Finishes"
      },
      {
        label: "Outdoor and Landscape",
        value: "Outdoor and Landscape"
      },
      {
        label: "Plumbing and HVAC",
        value: "Plumbing and HVAC"
      },
      {
        label: "Technology and Equipment",
        value: "Technology and Equipment"
      },
      {
        label: "Hardware and Fixtures",
        value: "Hardware and Fixtures"
      },
      {
        label: "Miscellaneous",
        value: "Miscellaneous"
      },
    ]

  },
  
   
 
]


